var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CategoryDefinitionForm',{attrs:{"title":"category","collection":"terms"}})
}
var staticRenderFns = []

export { render, staticRenderFns }